import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PostHogProvider } from 'posthog-js/react'

const root = ReactDOM.createRoot(document.getElementById("root"));
const apiKey = process.env.PUBLIC_POSTHOG_KEY || process.env.REACT_APP_POSTHOG_KEY;
const apiHost = process.env.PUBLIC_POSTHOG_HOST || process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const options = { api_host: apiHost };

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={apiKey}
      options={options}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
